import { css } from '@emotion/css';
// eslint-disable-next-line import/extensions
import { make as LottieController } from '@prezzee/ribbon/src/components/personal/LottieController/LottieController.bs.js';
import * as React from 'react';

const container = css({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
});

const icon = css({
  width: '45px',
});

const Spinner = () => (
  <div className={container}>
    <LottieController className={icon} path="https://assets5.lottiefiles.com/packages/lf20_p5zcfhtp.json" />
  </div>
);

export default Spinner;
